<template>
  <div style="margin: 0 0 12px;">
    <div class="dialog-top">
      <div class="image-box">
        <div class="image-box-title">美团评价</div>
        <el-image class="image-box-img" fit="cover" :src="cashForm.evaluationImg" @click.prevent="showImg(cashForm.evaluationImg)"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
      </div>
      <div class="image-box">
        <div class="image-box-title">实付截图</div>
        <el-image class="image-box-img" fit="cover" :src="cashForm.payImg" @click.prevent="showImg(cashForm.payImg)"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
      </div>
      <div class="image-box">
        <div class="image-box-title">收款码</div>
        <el-image class="image-box-img" fit="cover" :src="cashForm.payeeImg" @click.prevent="showImg(cashForm.payeeImg)"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
      </div>

    </div>

    <div style="width: 50%; flex: 1; margin: 0 auto">
      <el-form ref="formRef" :model="cashForm" label-width="auto" label-position="right">
        <el-form-item label="审核结果：">
          <el-radio-group v-model="state" @change="stateChange">
            <el-radio-button :label="2">通  过</el-radio-button>
            <el-radio-button :label="3">不通过</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="不通过图片：" v-if="state == 3">
          <el-checkbox-group v-model="checkList">
            <el-checkbox :label="2">美团评价</el-checkbox>
            <el-checkbox :label="4">实付截图</el-checkbox>
            <el-checkbox :label="8">收款码</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="不通过原因："  v-if="state == 3">
          <el-input type="textarea" :rows="3" v-model="cashForm.auditReason" placeholder="请简单描述不通过原因（必填项）" style="width: 100%; flex: 1"/>
        </el-form-item>
        <el-form-item label="">
          <el-button @click.native="cancel" >取消</el-button>
          <el-button type="primary" @click="summit">确定</el-button>
        </el-form-item>
      </el-form>
      <!--        <div class="dialog-footer" style="text-align: center; margin-top: 16px;">-->
      <!--          <el-button @click.native="cancel" >取消</el-button>-->
      <!--          <el-button type="primary" @click="summit">确定</el-button>-->
      <!--        </div>-->
    </div>


  </div>

</template>

<script>
import { postFormData, getFormData } from "@/api/api"
import {updateCashbackState} from "@/api/url";
import ImgViewer from "@/assets/js/imageViewer";

export default {
  name: "UserFromDialog",
  props: {
    value: Object
  },
  data() {
    return {
      cashForm: this.value.cashForm,
      state: this.value.cashForm.state,
      imgState: this.value.cashForm.imgState,
      checkList: []
    }
  },
  methods: {

    stateChange(val) {
      if(val == 1) {
        this.checkList = []
      }
    },

    showImg(img) {
      let imgList = []
      imgList.push(img)
      ImgViewer.open({
        imgList: imgList
      })
    },

    cancel() {
      this.$emit("close");
    },
    summit() {
      if(this.state < 2) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请选择审核结果',
          type: 'warning'
        });
        return false
      }
      if(this.state == 3 && this.checkList.length == 0) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请选择不通过图片',
          type: 'warning'
        });
        return false
      }
      if(this.state == 3 && !this.cashForm.auditReason) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请输入不通过原因',
          type: 'warning'
        });
        return false
      }
      let param = {}
      let arr = []
      arr.push(this.cashForm.id)
      param['idArr'] = arr
      if(this.state == 3) {
        let stateSum = 0
        this.checkList.map(item => {
          stateSum += item
        })
        param['imgState'] = stateSum
      }
      param['state'] = this.state
      param['auditReason'] = this.cashForm.auditReason
      postFormData(updateCashbackState, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm', param)
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
      })
    },


  },
  mounted() {
    if(this.cashForm.state == 3) {
      if((this.cashForm.imgState & 2) == 2){
        this.checkList.push(2)
      }
      if((this.cashForm.imgState & 4) == 4){
        this.checkList.push(4)
      }
      if((this.cashForm.imgState & 8) == 8) {
        this.checkList.push(8)
      }
    }
    console.log(this.cashForm.state)
    console.log(this.checkList)
  }
}
</script>

<style scoped>
.dialog-top {
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-bottom: 24px;

}
.image-box {
  width: 240px;
  height: 440px;
  background-color: #dddddd;
  overflow: hidden;
  position: relative;
  border: 1px solid #ededed;
  /*margin-right: 8px;*/
}

.image-box-img {
  width: 240px;
  height: 440px;
}

.image-box-title {
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(0,0,0,0.8);
  font-weight: bold;
  color: #ffffff;
  padding: 6px 12px;
  border-radius: 0 0 10px 0;
  z-index: 9;
  font-size: 12px;
  letter-spacing: 1px;
}
</style>
